import LoadingFailure from './LoadingFailure';
import { useContext } from 'react';
import { AuthContext } from './AuthContext';

export default function SessionRecovery({ compact = false }) {
  const { checkAuth, checkingSession, authError } = useContext(AuthContext);
  if (!compact) return <LoadingFailure error={authError} />;
  return (
    <section role="alert" className={compact ? 'border-b bg-primary px-4 py-3 text-secondary' : 'mx-auto max-w-lg p-8 text-center text-secondary'}>
      <h1 className={compact ? 'font-semibold' : 'text-xl font-semibold'}>Connection unavailable</h1>
      <p className="my-2">We couldn’t check your session. Check your connection and try again.</p>
      <button type="button" disabled={checkingSession} onClick={() => checkAuth()} className="rounded bg-accent px-4 py-2 text-white disabled:opacity-50">
        {checkingSession ? 'Checking connection…' : 'Retry'}
      </button>
    </section>
  );
}
